import { useQuery, UseQueryOptions } from "react-query";
import { FeatureFlagResponse, fetchFeatureFlag } from "../api/featureFlag";

type UseFacilityIndexOptions<Flag> = UseQueryOptions<
  FeatureFlagResponse<Flag>,
  Error,
  FeatureFlagResponse<Flag>,
  string[]
>;

export const useFeatureFlagQuery = <Flag>(
  flag: Flag,
  params?: Record<string, unknown>,
  options?: UseFacilityIndexOptions<Flag>
) =>
  useQuery([`FeatureFlag`, String(flag)], () => fetchFeatureFlag(flag, params), {
    ...options,
  });
